<hr style="margin-top: 0px; margin-bottom: 0px;">

<div *ngIf="importSchedulesReady && userGroupsReady && associatedUserGroupsReady; else loading" class="col-md-12">
    <p-confirmDialog #cd>
        <ng-template #footer>
            <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
            <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
        </ng-template>
    </p-confirmDialog>

    <div class="form-group">
        
        <p-table #importTable [columns]="importScheduleCols" [scrollable]="true" sortField="name" [value]="importSchedules" scrollHeight="60vh">
            <ng-template pTemplate="caption">
                <div style="text-align: left; margin-top: 10px; margin-bottom: 10px;">
                    <label style="font-size: large; vertical-align: middle; color:black; padding-right: 20px; font-weight: 500;">IMPORT & SYNC SCHEDULES</label>
                    <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                    <input (input)="importTable.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search Import Schedules" size="30"
                            style="width:auto; height: 35px" type="text" [(ngModel)]="scheduleSearchText" (ngModelChange)="searchSchedulesTextChanged()">
                    <button style="margin-left: 10px; margin-top: -6px;" type="button" class="btn btn-success" (click)="addNewSchedule(scheduleTemplate)">Create Schedule</button>
                    <label style="border: 1px dotted lightgray; width: 600px; height: 35px; padding-top: 7px; padding-left: 5px; color: #c8102e; margin-left: 10px; vertical-align: middle; margin-top: -5px; font-size: 14px;"
                            class="css-tooltip2" [attr.tooltip-data]="getRecentImportJobMessages()">{{lastImportJobStatusMessage}}</label>
                    <!-- <button style="margin-left: 10px; margin-top: -6px;" type="button" class="btn btn-success" (click)="importAll()">Import All</button> -->
                </div>
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr>
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [ngClass]="{'text-center': col.header == 'Logs' || col.header == 'Enabled'}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr *ngIf="rowData.userFeatureAccess['ViewListing'] || global.globalSwitch" style="height: 40px;" >
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{rowData.name}}
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{rowData.description}}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{rowData.displayedOwner}}
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        {{rowData.frequency}}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;" class="text-center">
                        <div *ngIf="!rowData.isDisabled" (click)="toggleImportEnableState(rowData)" style="cursor: pointer;">
                            <i class="fas fa-check-circle" style="color:#64a70b; font-size: 18px;"></i>
                        </div>
                        <div *ngIf="rowData.isDisabled" (click)="toggleImportEnableState(rowData)" style="cursor: pointer;">
                            <i class="fa-regular fa-circle" style="color:lightgrey; font-size: 18px;"></i>
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.modifiedDate | date : 'medium' }}
                    </td>

                    <td class="text-center" style="width: 60px;" [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <button (click)="openImportLogs(rowData)" class="btn btn-sm" style="background-color: var(--kig-section-header-bg);color: black;" type="button">Log</button>
                    </td>

                    <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.userFeatureAccess['CopySchedule']" class="text-center">
                            <div (click)="copySchedule(rowData)" aria-hidden="true" class="pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                            </div>
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;" class="text-center" >
                        <div *ngIf="rowData.userFeatureAccess['EditSchedule']"
                            (click)="editExistingSchedule(rowData,scheduleTemplate)" aria-hidden="true"
                            class="fas fa-pencil-alt text-center" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                        </div>
                        <div *ngIf="rowData.userFeatureAccess['ViewSchedule'] && !rowData.userFeatureAccess['EditSchedule']"
                            (click)="editExistingSchedule(rowData,scheduleTemplate)" aria-hidden="true"
                            class="far fa-eye text-center" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.userFeatureAccess['DeleteSchedule']" class="text-center">
                            <div (click)="onDeleteConfirm(rowData)" aria-hidden="true" class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;"></div>
                            <span class="sr-only">Delete</span>
                        </div>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </div>

    <ng-template #noResults>
        <p *ngIf="searchedImportSchedules">No Results Found</p>
    </ng-template>

</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin-top: 30px; margin-left: 30px; margin-right: 10px;"></i>
    <span>Loading...</span>
    </div>
</ng-template>


<ng-template #scheduleTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="schedule-modal">
    <!-- <div class="modal-content schedule-modal"> -->
      <div style="background-color: #548235;  height: 7px;"></div>
      <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">{{ importScheduleModalTitle }}</h5>
        <button
          (click)="scheduleModalRef.hide()"
          class="ms-auto fas fa-times" type="button"
          style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
      </div>
  
      <div class="modal-body" style="font-size: 15px;">
    
        <div style="margin-bottom: 20px; display: flex; gap: 20px;">
            <div class="form-group" style="width: 320px;">
                <label for="scheduleName" style="font-weight: 500;">Name*</label>
                <input [(ngModel)]="importSchedule.name" class="form-control" id="scheduleName" name="scheduleName" 
                  [style.color]="!duplicateScheduleName ? 'black' : 'red' " (ngModelChange)="duplicateScheduleNameCheck(importSchedule.name)"
                  required type="text">
            </div>
            <div class="form-group" style="width: 500px;">
                <label for="description" style="font-weight: 500;">Description</label>
                <input type="text" id="description" name="description" class="form-control" [(ngModel)]="importSchedule.description" required>
            </div>
            <div class="form-group" style="width: 360px;">
                <label for="UserGroup" style="font-weight: 500;">Access Group*</label>
                <ngx-select-dropdown name="userGroupSelection" [config]="userGroupConfig" [options]="associatedUserGroups" [(ngModel)]="selectedUserGroup" style="height: 26px;"></ngx-select-dropdown>  
            </div>
        </div>

        <div style="margin-bottom: 20px; display: flex; gap: 20px;">
            <div class="form-group" style="width: 320px;">
                <label for="UserGroup" style="font-weight: 500;">Data Source*</label>
                <ngx-select-dropdown name="dataSourceSelection" [config]="dataSourceConfig" [options]="dataSourceOptions" [(ngModel)]="importSchedule.dataSource" (change)="updateDropdownContent()"></ngx-select-dropdown>  
            </div>
            <div class="form-group" style="width: 600px;">
                <div *ngIf="importSchedule.dataSource != 'CSV File'">
                    <label for="Frequency" style="font-weight: 500;">Frequency*</label>
                    <div style="font-size: 14px; margin-top: 6px;">
                        <input type="radio" [(ngModel)]="importSchedule.frequency" name="freqDaily" value="Daily" />
                        <label style="padding-left: 5px;">Daily &#64; </label>
                        <input type="number" min="0" max="23" style="width: 50px;" [(ngModel)]="importSchedule.freqValue" />
                        <label style="padding-left: 5px; padding-right: 25px;">hour of day (UTC)</label>
                        <input type="radio" [(ngModel)]="importSchedule.frequency" name="freqHourly" value="Hourly" />
                        <label style="padding-left: 5px; padding-right: 25px;">Hourly</label>
                        <input type="radio" [(ngModel)]="importSchedule.frequency" name="freqEvery30Min" value="Every30Min" />
                        <label style="padding-left: 5px; padding-right: 25px;">Every 30 Min</label>
                        <input type="radio" [(ngModel)]="importSchedule.frequency" name="freqEvery15Min" value="Every15Min" />
                        <label style="padding-left: 5px; padding-right: 25px;">Every 15 Min</label>
                    </div>
                </div>
            </div>
            <div class="form-group" style="width: 255px;">
                <!-- <button (click)="modalRef.hide()" class="btn btn-primary pull-left" style="margin-right: 10px; margin-top: 10px; width: 150px;" type="button">Import Now</button> -->
                <label for="enabled" style="margin-right: 10px; margin-left: 195px; font-weight: 500;">Enabled</label>
                <div style="margin-left: 200px; margin-top: 5px;">
                    <p-toggleswitch  id="enabled" [ngModel]="!importSchedule.isDisabled" (ngModelChange)="importSchedule.isDisabled = !$event" [ngModelOptions]="{standalone: true}"
                        (onChange)="onScheduleEnable($event)" required>
                    </p-toggleswitch>
                </div>
            </div>
        </div>

        <!-- Weather Link -->

        <div *ngIf="importSchedule.dataSource == 'Weather Link'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Search for Weather Link Stations</div>

                <div class="card-body" style="font-size: 15px;">
                    <div style="display: flex; gap: 10px; justify-content: center;">
                        <div class="form-group" style="width: 350px;">
                            <div>
                                <label style="font-weight: 500;">Key</label>
                                <input type="text" id="lat" name="lat" class="form-control" [(ngModel)]="searchItemKey" required>
                            </div>
                        </div>

                        <div class="form-group" style="width: 350px;">
                            <div>
                                <label style="font-weight: 500;">Secret</label>
                                <input type="text" id="long" name="long" class="form-control" [(ngModel)]="searchItemSecret" required>
                            </div>
                        </div>

                        <div class="form-group" style="width: 150px;">
                            <button (click)="searchForItems(searchWLStationsResultsTemplate, false)" class="btn btn-primary" style="width: 150px; margin-top: 24px; float: right;" type="button">Search</button>  
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">View, Download, or Import Data</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>

                        <div class="form-group" style="width: 100px;">
                            <label style="font-weight: 500;">Feed</label>
                        </div>

                        <div class="form-group" style="width: 120px;"
                            *ngIf="importSchedule.importItems.length > 0">
                            <label style="font-weight: 500;">Station ID</label>
                        </div>

                        <div class="form-group" style="width: 150px;" *ngIf="importSchedule.importItems.length > 0">
                            <label style="font-weight: 500;">Station Name</label>
                        </div>

                        <div class="form-group" style="width: 100px;" *ngIf="importSchedule.importItems.length > 0">
                            <label style="font-weight: 500;">Subscription</label>
                        </div>

                        <div class="form-group" style="width: 100px;" *ngIf="importSchedule.importItems.length > 0">
                            <label style="font-weight: 500;">Latitude</label>
                        </div>

                        <div class="form-group" style="width: 100px;" *ngIf="importSchedule.importItems.length > 0">
                            <label style="font-weight: 500;">Longitude</label>
                        </div>

                        <div class="form-group" style="width: 275px;">
                            <label style="font-weight: 500;">Reading Types</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="previewReady(importItem)"
                                (click)="previewImportItemData(importItem, importSchedule.dataSource, searchSensorDataResultsTemplate)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            <div *ngIf="!previewReady(importItem)" style="width: 40px;"></div>

                            <div class="form-group" style="width: 100px;">
                                <select
                                    name="{{'Feed' + i}}"
                                    [(ngModel)]="importItem.feed"
                                    style="height:35px; width: 100px; border-color: lightgray;"
                                    (ngModelChange)="feedSelectionChanged(importItem, importSchedule.dataSource)"
                                    [disabled]="importItem.details.subscription_Type.toLowerCase() == 'basic'">
                                    <option [value]="i" *ngFor="let i of SourceFeedOptions">{{i}}</option>
                                </select>
                            </div>

                            <div class="form-group" style="width: 120px;">
                                <label style="height:35px; width: 120px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.refId }}
                                </label>
                            </div>

                            <div class="form-group" style="width: 150px;">
                                <label style="height:35px; width: 150px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.thingName }}
                                </label>
                            </div>

                            <div class="form-group" style="width: 100px;">
                                <label style="height:35px; width: 100px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.details.subscription_Type }}
                                </label>
                            </div>

                            <div class="form-group" style="width: 100px;" >
                                <label style="height:35px; width: 100px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.latitudeDaily }}
                                </label>
                            </div>

                            <div class="form-group" style="width: 100px;"  >
                                <label style="height:35px; width: 100px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.longitudeDaily }}
                                </label>
                            </div>

                            <div class="form-group" style="width: 275px; height: 38px;">
                                <ngx-select-dropdown
                                    [multiple]=true
                                    [(ngModel)]="importItem.dataTypesSelected"
                                    [config]="datatypeDropDownSettings"
                                    [options]="importItem.dataTypeOptions">
                                </ngx-select-dropdown>
                            </div>

                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>

                            <input type="date" id="starttime" name="starttime" class="form-control" [(ngModel)]="sensorReadingTypesStartDate" style="border: 0px; width: 20px; padding: 0px;" (change)="getDataTypesForThing(importItem, importSchedule.dataSource)" required>            

                            <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="copyImportItem(importItem)">
                            </div>

                            <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="delImportItem(importItem)">
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Weather Pillar -->

        <div *ngIf="importSchedule.dataSource == 'Weather Pillar'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Search for Weather Pillar Stations</div>

                <div class="card-body" style="font-size: 15px;">
                    <div style="display: flex; gap: 10px; justify-content: center;">
                        <div class="form-group" style="width: 200px;">
                            <div>
                                <label style="font-weight: 500;">Latitude</label>
                                <input type="text" id="lat" name="lat" class="form-control" [(ngModel)]="searchItemLatitude" required>
                            </div>
                        </div>
                        <div class="form-group" style="width: 200px;">
                            <div>
                                <label style="font-weight: 500;">Longitude</label>
                                <input type="text" id="long" name="long" class="form-control" [(ngModel)]="searchItemLongitude" required>
                            </div>
                        </div>

                        <div class="form-group" style="width: 100px;">
                            <label for="searchSensorRadius" style="font-weight: 500;">Radius (km)</label>
                            <input [(ngModel)]="searchItemRadius" class="form-control" id="searchItemRadius" name="searchItemRadius" required type="text">
                        </div>
                        <div class="form-group" style="width: 150px;">
                            <button (click)="searchForItems(searchWPStationsResultsTemplate, true)" class="btn btn-primary" style="width: 150px; margin-top: 24px; float: right;" type="button">Search</button>  
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">View, Download, or Import Data</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>
                        <div class="form-group" style="width: 105px;">
                            <label style="font-weight: 500;">Feed</label>
                        </div>

                        <div class="form-group" style="width: 180px;"
                            *ngIf="importSchedule.importItems.length > 0 && (importSchedule.importItems[0].feed == 'SubDaily' || importSchedule.importItems[0].feed.endsWith('Sta'))">
                            <label style="font-weight: 500;">Station ID</label>
                        </div>
                        <div class="form-group" style="width: 150px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed == 'SubDaily'">
                            <label style="font-weight: 500;">Station/Node Name</label>
                        </div>

                        <div class="form-group" style="width: 100px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed != 'SubDaily'">
                            <label style="font-weight: 500;">Crop</label>
                        </div>
                        <div class="form-group" style="width: 95px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed != 'SubDaily'">
                            <label style="font-weight: 500;">Local Time</label>
                        </div>

                        <div class="form-group" style="width: 130px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed.endsWith('LL')">
                            <label style="font-weight: 500;">Latitude</label>
                        </div>
                        <div class="form-group" style="width: 130px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed.endsWith('LL')">
                            <label style="font-weight: 500;">Longitude</label>
                        </div>
                        <div class="form-group" style="width: 60px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed.endsWith('LL')">
                            <label style="font-weight: 500;">Radius</label>
                        </div>

                        <div class="form-group" style="width: 300px;" *ngIf="importSchedule.importItems.length > 0 && importSchedule.importItems[0].feed == 'SubDaily'">
                            <label style="font-weight: 500;">Port Info</label>
                        </div>
                        <div class="form-group" style="width: 275px;">
                            <label style="font-weight: 500;">Reading Types</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="previewReady(importItem)"
                                (click)="previewImportItemData(importItem, importSchedule.dataSource, searchSensorDataResultsTemplate)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            <div *ngIf="!previewReady(importItem)" style="width: 40px;"></div>

                            <div class="form-group" style="width: 105px;">
                                <select
                                    name="{{'Feed' + i}}"
                                    [(ngModel)]="importItem.feed"
                                    style="height:35px; width: 105px; border-color: lightgray;"
                                    (ngModelChange)="feedSelectionChanged(importItem, importSchedule.dataSource)">
                                    <option [value]="i" *ngFor="let i of SourceFeedOptions">{{i}}</option>
                                </select>
                            </div>

                            <div class="form-group" style="width: 180px;"  *ngIf="importItem.feed == 'SubDaily' || importItem.feed.endsWith('Sta')">
                                <label style="height:35px; width: 180px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.thingName }}
                                </label>
                            </div>
                            <div class="form-group" style="width: 150px;"  *ngIf="importItem.feed == 'SubDaily'">
                                <label style="height:35px; width: 150px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    {{ importItem.details.nodeName }}
                                </label>
                            </div>
                            <div class="form-group" style="width: 300px;"  *ngIf="importItem.feed == 'SubDaily'">
                                <label style="height:35px; width: 300px; border: 1px solid lightgray; background-color: rgb(250, 250, 250); padding: 4px; position: relative; text-overflow: ellipsis; white-space: nowrap;">
                                    Port:{{importItem.details.port_number}}, {{importItem.details.manufacturer}}, {{importItem.details.product_name}}
                                </label>
                            </div>

                            <div class="form-group" style="width: 100px;"  *ngIf="importItem.feed != 'SubDaily'">
                                <select
                                    name="{{'CropSel' + i}}"
                                    [(ngModel)]="importItem.details.crop"
                                    style="height:35px; width: 100px; border-color: lightgray;">
                                    <option [value]="i" *ngFor="let i of WPCropOptions">{{i}}</option>
                                </select>
                            </div>
                            <div class="form-group" style="width: 95px;"  *ngIf="importItem.feed != 'SubDaily'">
                                <select
                                    name="{{'LocaltimeSel' + i}}"
                                    [(ngModel)]="importItem.details.useLocalTime"
                                    style="height:35px; width: 95px; border-color: lightgray;">
                                    <option [value]="i" *ngFor="let i of WPUseLocalTimeOptions">{{i}}</option>
                                </select>
                            </div>

                            <div class="form-group" style="width: 130px;"  *ngIf="importItem.feed.endsWith('LL')">
                                <input type="text" name="{{'Latitude' + i}}" class="form-control" [(ngModel)]="importItem.latitudeDaily" required>
                            </div>
                            <div class="form-group" style="width: 130px;"  *ngIf="importItem.feed.endsWith('LL')">
                                <input type="text" name="{{'Longitude' + i}}" class="form-control" [(ngModel)]="importItem.longitudeDaily" required>
                            </div>
                            <div class="form-group" style="width: 60px;"  *ngIf="importItem.feed.endsWith('LL')">
                                <input type="text" name="{{'Radius' + i}}" class="form-control" [(ngModel)]="importItem.radiusDaily" required>
                            </div>

                            <div class="form-group" style="width: 275px; height: 38px;">
                                <ngx-select-dropdown
                                    [multiple]=true
                                    [(ngModel)]="importItem.dataTypesSelected"
                                    [config]="datatypeDropDownSettings"
                                    [options]="importItem.dataTypeOptions">
                                </ngx-select-dropdown>
                            </div>

                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>

                            <!-- <div class="form-group fa-solid fa-rotate" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="getDataTypesForThing(importItem, importSchedule.dataSource)">
                            </div> -->

                            <!-- <div class="css-tooltip" [attr.tooltip-data]="Search for reading types" style="margin-top: 6px;"> -->
                                <input type="date" id="starttime" name="starttime" class="form-control" [(ngModel)]="sensorReadingTypesStartDate" style="border: 0px; width: 20px; padding: 0px;" (change)="getDataTypesForThing(importItem, importSchedule.dataSource)" required>            
                            <!-- </div> -->

                            <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="copyImportItem(importItem)">
                            </div>

                            <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="delImportItem(importItem)">
                            </div>

                            <div *ngIf="lastel" class="form-group fas fa-plus" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="addImportItem('')">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="importSchedule.importItems.length == 0" class="form-group fas fa-plus"
                        style="color:black; cursor: pointer; font-size: 14px; width: 30px;" (click)="addImportItem('', '', 0, 0, '', undefined)">
                    </div>
                </div>
            </div>
            <label style="font-size: 13px; margin-left: 5px; margin-top: 10px;">Note: SubDaily are values captured approximately every 15 min</label><br>
            <label style="font-size: 13px; margin-left: 40px;">DailyAvgLL & DailyObsLL are daily average and observation using Lat/Long</label><br>
            <label style="font-size: 13px; margin-left: 40px;">DailyObsSta is daily observation using a Station ID</label>
        </div>

        <!-- SenTek -->

        <div *ngIf="importSchedule.dataSource == 'SenTek'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Search for SenTek Sensor Systems</div>

                <div class="card-body">
                    <div style="display: flex; gap: 10px; justify-content: center;">
                        <div class="form-group" style="width: 400px;">
                            <div>
                                <label style="font-weight: 500;">SenTek-IrriMax Key</label>
                                <input type="text" id="SenTekKey" name="SenTekKey" class="form-control" [(ngModel)]="searchItemKey" required>
                            </div>
                        </div>
                        <div class="form-group" style="width: 150px;">
                            <button (click)="searchForItems(searchSensorResultsTemplateA, false)" class="btn btn-primary" style="width: 150px; margin-top: 24px; float: right;" type="button">Search</button>  
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">View, Download, and Import Data</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>
                        <div class="form-group" style="width: 100px;">
                            <label style="font-weight: 500;">Ref ID</label>
                        </div>
                        <div class="form-group" style="width: 100px;">
                            <label style="font-weight: 500;">Name</label>
                        </div>
                        <div class="form-group" style="width: 135px;">
                            <label style="font-weight: 500;">Latitude</label>
                        </div>
                        <div class="form-group" style="width: 135px;">
                            <label style="font-weight: 500;">Longitude</label>
                        </div>
                        <div class="form-group" style="width: 250px;">
                            <label style="font-weight: 500;">Reading Types</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="previewReady(importItem)"
                                (click)="previewImportItemData(importItem, importSchedule.dataSource, searchSensorDataResultsTemplate)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            
                            <div *ngIf="!previewReady(importItem)" style="width: 40px;"></div>

                            <div class="form-group" style="width: 100px;">
                                <input type="text" name="{{'Sensor' + i}}" class="form-control" [(ngModel)]="importItem.refId" required>
                            </div>

                            <div class="form-group" style="width: 100px;">
                                <input type="text" name="{{'Name' + i}}" class="form-control" [(ngModel)]="importItem.thingName" required>
                            </div>

                            <div class="form-group" style="width: 135px;">
                                <input type="text" name="{{'Latitude' + i}}" class="form-control" [(ngModel)]="importItem.latitudeDaily" required>
                            </div>

                            <div class="form-group" style="width: 135px;">
                                <input type="text" name="{{'Longitude' + i}}" class="form-control" [(ngModel)]="importItem.longitudeDaily" required>
                            </div>

                            <div class="form-group" style="width: 250px;">
                                <ngx-select-dropdown
                                    [multiple]=true
                                    [(ngModel)]="importItem.dataTypesSelected"
                                    [config]="datatypeDropDownSettings"
                                    [options]="importItem.dataTypeOptions">
                                </ngx-select-dropdown>
                            </div>

                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>
                            <div class="form-group fa-solid fa-rotate" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="getDataTypesForThing(importItem, importSchedule.dataSource)">
                            </div>
                            <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="copyImportItem(importItem)">
                            </div>
                            <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="delImportItem(importItem)">
                            </div>
                            <div *ngIf="lastel" class="form-group fas fa-plus" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="addImportItem('')">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="importSchedule.importItems.length == 0" class="form-group fas fa-plus"
                        style="color:black; cursor: pointer; font-size: 14px; width: 30px;" (click)="addImportItem('')">
                    </div>
                </div>
            </div>
        </div>
        
        <!-- IRROCloud -->

        <div *ngIf="importSchedule.dataSource == 'IRROCloud'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Search for IRROCloud Sensor Systems</div>

                <div class="card-body">
                    <div style="display: flex; gap: 10px; justify-content: center;">
                        <div class="form-group" style="width: 600px;">
                            <div>
                                <label style="font-weight: 500;">IRROCloud Token (ex: "token 6c77c17ec56daa412fb403fad97fbade314d1815")</label>
                                <input type="text" id="IRROCloudUser" name="IRROCloudUser" class="form-control" [(ngModel)]="searchItemKey" required>
                            </div>
                        </div>

                        <div class="form-group" style="width: 150px;">
                            <button (click)="searchForItems(searchSensorResultsTemplateA, false)" class="btn btn-primary" style="width: 150px; margin-top: 24px; float: right;" type="button">Search</button>  
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">View, Download, and Import Data</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>
                        <div class="form-group" style="width: 100px;">
                            <label style="font-weight: 500;">ID</label>
                        </div>
                        <div class="form-group" style="width: 100px;">
                            <label style="font-weight: 500;">Name</label>
                        </div>
                        <div class="form-group" style="width: 135px;">
                            <label style="font-weight: 500;">Latitude</label>
                        </div>
                        <div class="form-group" style="width: 135px;">
                            <label style="font-weight: 500;">Longitude</label>
                        </div>
                        <div class="form-group" style="width: 250px;">
                            <label style="font-weight: 500;">Reading Types</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="previewReady(importItem)"
                                (click)="previewImportItemData(importItem, importSchedule.dataSource, searchSensorDataResultsTemplate)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            
                            <div *ngIf="!previewReady(importItem)" style="width: 40px;"></div>

                            <div class="form-group" style="width: 100px;">
                                <input type="text" name="{{'Sensor' + i}}" class="form-control" [(ngModel)]="importItem.refId" disabled="true" required>
                            </div>

                            <div class="form-group" style="width: 100px;">
                                <input type="text" name="{{'Name' + i}}" class="form-control" [(ngModel)]="importItem.thingName" disabled="true" required>
                            </div>

                            <div class="form-group" style="width: 135px;">
                                <input type="text" name="{{'Latitude' + i}}" class="form-control" [(ngModel)]="importItem.latitudeDaily" disabled="true" required>
                            </div>

                            <div class="form-group" style="width: 135px;">
                                <input type="text" name="{{'Longitude' + i}}" class="form-control" [(ngModel)]="importItem.longitudeDaily" disabled="true" required>
                            </div>

                            <div class="form-group" style="width: 250px;">
                                <ngx-select-dropdown
                                    [multiple]=true
                                    [(ngModel)]="importItem.dataTypesSelected"
                                    [config]="datatypeDropDownSettings"
                                    [options]="importItem.dataTypeOptions">
                                </ngx-select-dropdown>
                            </div>

                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>
                            <div class="form-group fa-solid fa-rotate" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="getDataTypesForThing(importItem, importSchedule.dataSource)">
                            </div>
                            <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="copyImportItem(importItem)">
                            </div>
                            <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="delImportItem(importItem)">
                            </div>
                            <div *ngIf="lastel" class="form-group fas fa-plus" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="addImportItem('')">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="importSchedule.importItems.length == 0" class="form-group fas fa-plus"
                        style="color:black; cursor: pointer; font-size: 14px; width: 30px;" (click)="addImportItem('')">
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Soiltech -->

        <div *ngIf="importSchedule.dataSource == 'Soiltech'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Search for Soiltech Sensors</div>

                <div class="card-body">
                    <div style="display: flex; gap: 10px; justify-content: center;">
                        <button (click)="searchForItems(searchSensorResultsTemplateA, false)" class="btn btn-primary" style="width: 150px; margin-top: 24px; float: right;" type="button">Search</button>  
                        <button (click)="showSoiltechReadingTypeKey(soiltechReadingTypeKey)" class="btn btn-basic" style="width: 250px; margin-top: 24px; margin-left: 30px; border: 1px solid lightgray;" type="button">Key for Soiltech Reading Types</button>  
                    </div>
                </div>
            </div>
            <br>

            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">View, Download, and Import Data</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>
                        <div class="form-group" style="width: 200px;">
                            <label style="font-weight: 500;">Device ID</label>
                        </div>
                        <div class="form-group" style="width: 270px;">
                            <label style="font-weight: 500;">Display Name</label>
                        </div>
                        <div class="form-group" style="width: 250px;">
                            <label style="font-weight: 500;">Reading Types</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="previewReady(importItem)"
                                (click)="previewImportItemData(importItem, importSchedule.dataSource, searchSensorDataResultsTemplate)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            
                            <div *ngIf="!previewReady(importItem)" style="width: 40px;"></div>

                            <div class="form-group" style="width: 200px;">
                                <input type="text" name="{{'Sensor' + i}}" class="form-control" [(ngModel)]="importItem.thingName" required>
                            </div>

                            <div class="form-group" style="width: 270px;">
                                <input type="text" name="{{'Name' + i}}" class="form-control" [(ngModel)]="importItem.thingSubName" required>
                            </div>

                            <div class="form-group" style="width: 250px;">
                                <ngx-select-dropdown
                                    [multiple]=true
                                    [(ngModel)]="importItem.dataTypesSelected"
                                    [config]="datatypeDropDownSettings"
                                    [options]="importItem.dataTypeOptions">
                                </ngx-select-dropdown>
                            </div>

                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>
                            <div class="form-group fa-solid fa-rotate" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="getDataTypesForThing(importItem, importSchedule.dataSource)">
                            </div>
                            <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="copyImportItem(importItem)">
                            </div>
                            <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="delImportItem(importItem)">
                            </div>
                            <div *ngIf="lastel" class="form-group fas fa-plus" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="addImportItem('')">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="importSchedule.importItems.length == 0" class="form-group fas fa-plus"
                        style="color:black; cursor: pointer; font-size: 14px; width: 30px;" (click)="addImportItem('')">
                    </div>
                </div>
            </div>
        </div>


        <div *ngIf="importSchedule.dataSource == 'Zentra'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Enter Zentra Cloud API Key</div>
                <div class="card-body">
                    <div style="display: flex; gap: 10px; justify-content: center;">
                        <div class="form-group" style="width: 700px;">
                            <div>
                                <label>Zentra Cloud API Key (Ex: "Token d2ef506e4b30af05cf3daddde43adeabc5ff6ea7")</label>
                                <input type="text" id="ZentraAPI" name="ZentraAPI" class="form-control" [(ngModel)]="searchItemKey" required>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">View, Download, and Import Data</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>
                        <div class="form-group" style="width: 125px;">
                            <label style="font-weight: 500;">Device SN</label>
                        </div>
                        <div class="form-group" style="width: 350px;">
                            <label style="font-weight: 500;">Reading Types</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="previewReady(importItem)"
                                (click)="previewImportItemData(importItem, importSchedule.dataSource, searchSensorDataResultsTemplate)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            <div *ngIf="!previewReady(importItem)" style="width: 40px;"></div>

                            <div class="form-group" style="width: 125px;">
                                <input type="text" name="{{'Sensor' + i}}" class="form-control" [(ngModel)]="importItem.thingName" required>
                            </div>

                            <div class="form-group" style="width: 350px;">
                                <ngx-select-dropdown
                                    [multiple]=true
                                    [(ngModel)]="importItem.dataTypesSelected"
                                    [config]="datatypeDropDownSettings"
                                    [options]="importItem.dataTypeOptions">
                                </ngx-select-dropdown>
                            </div>

                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>

                            <!-- <div class="form-group fa-solid fa-rotate" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="getDataTypesForThing(importItem, importSchedule.dataSource)">
                            </div> -->
                            <input type="date" id="starttime" name="starttime" class="form-control" [(ngModel)]="sensorReadingTypesStartDate" style="border: 0px; width: 20px; padding: 0px;" (change)="getDataTypesForThing(importItem, importSchedule.dataSource)" required>            


                            <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="copyImportItem(importItem)">
                            </div>
                            <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="delImportItem(importItem)">
                            </div>
                            <div *ngIf="lastel" class="form-group fas fa-plus" style="color:black; cursor: pointer; font-size: 18px; width: 20px; margin-top: 10px; text-align: center;"
                                (click)="addImportItem('', '', 0, 0, searchItemKey)">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="importSchedule.importItems.length == 0" class="form-group fas fa-plus"
                        style="color:black; cursor: pointer; font-size: 14px; width: 30px;" (click)="addImportItem('', '', 0, 0, searchItemKey)">
                    </div>
                </div>
            </div>
        </div>

        
        <div *ngIf="importSchedule.dataSource == 'Maintenance Connection Sync'" >
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">Analyze and Update Sensors</div>
                <div class="card-body">
                    <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 40px;">
                            <label style="font-weight: 500;">View</label>
                        </div>
                        <div class="form-group" style="width: 375px;">
                            <label style="font-weight: 500;">Device Class</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px;">MC Count</label>
                        </div>

                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">{{global.appName}}.New</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">{{global.appName}}.Name</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">{{global.appName}}.ProdId</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">{{global.appName}}.Group</label>
                        </div>
                        
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">Par.New</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">Par.Name</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">Par.ProdId</label>
                        </div>
                        <div class="form-group text-center" style="width: 70px;">
                            <label style="font-weight: 500; font-size: 14px; color: #c8102e;">Par.Group</label>
                        </div>
                        <div class="form-group text-center" style="width: 30px;">
                            <label style="font-weight: 500; font-size: 14px; color: black;">Sync</label>
                        </div>
                    </div>

                    <div *ngFor="let importItem of importSchedule.importItems; let i = index; let firstel = first; let lastel = last ">
                        <div style="margin-bottom: 10px; display: flex; gap: 10px;">
                            <div *ngIf="importItem.thingName != ''"
                                (click)="compareSyncMcSensors(importItem, false, searchSensorResultsTemplateB)" aria-hidden="true" class="far fa-eye text-center"
                                style="color:#1c4966; cursor: pointer; font-size: 14px; width: 40px; margin-top: 12px;">
                            </div>
                            <div *ngIf="importItem.thingName == ''" style="width: 40px;"></div>

                            <div class="form-group" style="width: 250px;">
                                <input type="text" name="{{'Sensor' + i}}" class="form-control" [(ngModel)]="importItem.thingName" required>
                            </div>
                           
                            <div *ngIf="importItem.isLoadingDataTypes" style="margin-left: -75px; margin-right: 40px; margin-top: 10px; font-size: 6px;">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </div>

                            <div style="width: 115px;">
                                <div class="form-group pi pi-copy" style="color:#1c4966; cursor: pointer; font-size: 18px; width: 30px; margin-top: 10px; text-align: center;"
                                    (click)="copyImportItem(importItem)">
                                </div>
                                <div class="form-group far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 18px; width: 30px; margin-top: 10px; text-align: center;"
                                    (click)="delImportItem(importItem)">
                                </div>
                                <div *ngIf="lastel" class="form-group fas fa-plus" style="color:black; cursor: pointer; font-size: 18px; width: 30px; margin-top: 10px; text-align: center;"
                                    (click)="addImportItem('', '', 0, 0, searchItemKey)">
                                </div>
                            </div>

                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'MCCount' + i}}" style="text-align: center;" class="form-control" disabled="true" [(ngModel)]="importItem.compareSyncResults.sensors.length" required>
                            </div>

                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'KigNew' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.kigNew" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'KigNameUpdate' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.kigNameUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'KigProdIdUpdate' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.kigProdIdUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'KigGroupUpdate' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.kigGroupUpdate" required>
                            </div>

                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'ParNew' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.particleNew" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'ParNameUpdate' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.particleNameUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'ParProdIdUpdate' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.particleProdIdUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="{{'ParGroupUpdate' + i}}" style="text-align: center" class="form-control" disabled="true" [(ngModel)]="importItem.compareStats.particleGroupUpdate" required>
                            </div>

                            <div *ngIf="this.importSchedule.userFeatureAccess['EditSchedule'] && importItem.compareStats.syncNeeded"
                                (click)="compareSyncMcSensors(importItem, true, null)" aria-hidden="true" class="fa-solid fa-right-left text-center"
                                style="color: black; cursor: pointer; font-size: 14px; width: 26px; margin-top: 13px;">
                            </div>
                        </div>
                    </div>
                    <div *ngIf="importSchedule.importItems.length == 0" class="form-group fas fa-plus"
                        style="color:black; cursor: pointer; font-size: 14px; width: 30px;" (click)="addImportItem('', '', 0, 0, searchItemKey)">
                    </div>
                </div>
            </div>
        </div>


        <div *ngIf="importSchedule.dataSource == 'CSV File'">
            <div class="card">
                <div style="background-color: var(--kig-section-header-bg); color: black; font-size: 18px; padding-left: 10px; padding-top: 3px; height: 30px;">CSV File</div>
                <div class="card-body">
                    <div style="display: flex; gap: 10px;">
                        <div class="form-group" style="width: 750px;">
                            <label style="width: 900px; margin-bottom: 10px;" for="file">Select comma delimited CSV file. Pre-processing info shown after selecting file. Preview shows upto 300 records.</label>
                            <button (click)="displaySampleCSVFormat(sampleCSVFormatsTemplate)" class="btn btn-primary btn-sm" style="width: 150px; margin-right: 20px;" type="button">Sample Formats</button>  
                            <input type="file" id="file" accept=".csv" (change)="selectCSVFile($event)">
                        </div>
                        <div class="form-group" style="width: 120px;">
                            <button  *ngIf="readyToImportFileContent()" (click)="importCSVFileContent()" class="btn btn-primary btn-sm" style="width: 100px; margin-top: 35px; float: right;" type="button">Import</button>  
                            <i *ngIf="analyzingCSVFile" style="margin-top: 20px;" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                        </div>
                    </div>

                    <div class="form-group" style="width: 880px; margin-top: 15px; margin-bottom: 15px;">
                        <div *ngIf="importCSVFileAnalysisResults != ''" style="font-size: 14px; height: 30px; color: red; background-color: lightgray; padding: 5px;">
                            {{importCSVFileAnalysisResults}}
                        </div>
                        <div *ngIf="importCSVFileAnalysisResults == ''">
                            <table class="table" style="width:100%; border: 1px dotted lightgray;">
                                <tr style="font-size: 14px; line-height: 18px; background-color: var(--kig-section-header-bg);">
                                    <td align="center">Records</td>
                                    <td align="center">Unique UUIDs</td>
                                    <td align="center">New UUIDs</td>
                                    <td align="center">with GPS</td>
                                    <td align="center">with Existing Readings</td>
                                    <td align="center">New ReadingTypes</td>
                                    <td align="center">Imported</td>
                                </tr>
                                <tr style="font-size: 14px; line-height: 18px;">
                                    <td align="center">{{csvFileAnalysisResults.records}}</td>
                                    <td align="center">{{csvFileAnalysisResults.uniqueUUIDs}}</td>
                                    <td align="center" style="color: green;">{{csvFileAnalysisResults.newUUIDs}}</td>
                                    <td align="center">{{csvFileAnalysisResults.recordsWithGPS}}</td>
                                    <td align="center" style="color: red;">{{csvFileAnalysisResults.existingRecords}}</td>
                                    <td align="center">{{csvFileAnalysisResults.numNewReadingTypes}}</td>
                                    <td align="center">{{csvFileAnalysisResults.recordsImported}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div style="height: 20em; overflow-y: scroll; overflow-x: auto; white-space: nowrap; border: 1px dotted lightgray;"> 
                        <table class="table" style="width:100%;">
                            <tr *ngFor="let record of csvFileContentShown; let i = index" style="font-size: 14px; line-height: 4px;">
                                <td *ngFor="let col of record; let j = index" style="font-size: 14px;  padding: 5px;" [ngStyle]="{'color': getRecordColor(i)}">
                                    <div *ngIf="i == 0" style="font-size: 14px;  background-color: var(--kig-section-header-bg);">
                                        {{ record[j] }}
                                    </div>
                                    <div *ngIf="i > 0" style="font-size: 14px;  background-color: white;">
                                        {{ record[j] }}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                </div>
            </div>
        </div>

        <br>
        <div *ngIf="importSchedule.dataSource == 'Weather Pillar' || importSchedule.dataSource == 'SenTek' || importSchedule.dataSource == 'Soiltech' || importSchedule.dataSource == 'Zentra' || importSchedule.dataSource == 'Weather Link' || importSchedule.dataSource == 'IRROCloud'">
            <button (click)="manualImport(importNowTemplate)" class="btn btn-primary pull-left" style="margin-right: 10px; width: 150px;" type="button">Manual Import</button>
        </div> 
        <label style="border: 1px dotted lightgray; width: 670px; height: 35px; padding-top: 7px; padding-left: 5px; color: #c8102e; margin-left: 5px; vertical-align: middle; margin-top: 0px; font-size: 14px;"
                class="css-tooltip2" [attr.tooltip-data]="getRecentImportJobMessages()">{{lastImportJobStatusMessage}}</label>
        <button (click)="saveSchedule()" class="btn btn-success pull-right" style="margin-right: 10px;" type="button">{{ importScheduleModalButtonTitle }}</button>
      </div>
    </div>
</ng-template>

<!-- --Weather Pillar Station Search Results Modal-- -->

<ng-template #searchWPStationsResultsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="wpStationResults-modal">
    <!-- <div class="modal-content wpStationResults-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Search Results - Number of stations and nodes: {{importSearchResults.length}}</h5>
            <button
            (click)="searchResultsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <p-table #searchResultsTable [columns]="importSearchResultWPCols" [scrollable]="true" [value]="importSearchResults" scrollHeight="40em">
            <ng-template pTemplate="caption">
                <div style="display: flex; gap: 10px;">
                    <label for="sensorGroupName" style="font-size: 17px; margin-top: 4px;">Search</label>
                    <i class="fa fa-search" style="margin:10px 0px 0px 0px; "></i>
                    <input type="text" pInputText size="30" placeholder="Search Table" 
                            (input)="searchResultsTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 35px">
                    <button (click)="importCheckedThings()" class="btn btn-primary" style="margin-top: -2px; margin-left: 10px; margin-right: 10px;" type="button">Add Checked Items</button>

                    <label style="font-size: 14px; margin-top: 4px; margin-left: 5px;">Date Color Key:</label>
                    <label style="font-size: 14px; margin-top: 4px; color: #64a70b"><i class="fa-solid fa-square"></i> Day,</label>
                    <label style="font-size: 14px; margin-top: 4px; color: #dadb26"><i class="fa-solid fa-square"></i> Week,</label>
                    <label style="font-size: 14px; margin-top: 4px; color: #ff9551"><i class="fa-solid fa-square"></i> Month,</label>
                    <label style="font-size: 14px; margin-top: 4px; color: purple"><i class="fa-solid fa-square"></i> 6 Months,</label>
                    <label style="font-size: 14px; margin-top: 4px; color: #f93232"><i class="fa-solid fa-square"></i> 6+ Months</label>
                </div>
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                    <!-- <p-sortIcon *ngIf="col.header=='Distance'" [field]="col.field"></p-sortIcon> -->
                </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr style="height: 40px;">
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        <p-checkbox
                            [(ngModel)]="rowData.checked" binary="true" id="{{rowData.checked}}" name="{{rowData.checked}}"
                            [ngModelOptions]="{standalone: true}">
                        </p-checkbox>
                    </td>

                    <td [ngStyle]="{'width': columns[1].width }" style="flex: none; border-width: 0px; font-size: 14px;">
                        <div *ngIf="!rowData.isLoadingLastReading" [ngStyle]="{'color': rowData.lastReportColor }">
                            <i class="fa-solid fa-square"></i>
                            {{ rowData.lastReportDate | date : 'medium' }}
                        </div>
                        <div *ngIf="rowData.isLoadingLastReading" style="font-size: 6px;">
                            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.thingId }}
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.thingName }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width }" style="flex: none; border-width: 0px;">
                        <div *ngIf="!rowData.isLoadingParentDevice" class="css-tooltip" [attr.tooltip-data]="rowData.parentTooltips" style="cursor: pointer;">
                            {{ rowData.nodeType }}
                        </div>
                        <div *ngIf="rowData.isLoadingParentDevice" style="font-size: 6px;">
                            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[5].width }" style="flex: none; border-width: 0px;">
                        {{ rowData.nodeName }}
                    </td>

                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.source }}
                    </td>

                    <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.latitude }}
                    </td>

                    <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.longitude }}
                    </td>

                    <!-- <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.elevation }}
                    </td> -->

                    <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.distance | number:'1.2-2' }}
                    </td>
                </tr>
            </ng-template>

            <ng-template #noResults>
                <p *ngIf="importSearchResults.length <= 0">No Results Found</p>
            </ng-template>
        </p-table>
        <br>
    </div>
</ng-template>

<!-- --Weather Link Station Search Results Modal-- -->

<ng-template #searchWLStationsResultsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="wlStationResults-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Search Results</h5>
            <button
            (click)="searchResultsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <p-table #searchResultsTable [columns]="importSearchResultWLCols" [scrollable]="true" [value]="importSearchResults" scrollHeight="40em">
            <ng-template pTemplate="caption">
                <div style="display: flex; gap: 10px;">
                    <label for="sensorGroupName" style="font-size: 17px; margin-top: 4px;">Search</label>
                    <i class="fa fa-search" style="margin:10px 0px 0px 0px; "></i>
                    <input type="text" pInputText size="30" placeholder="Search Table" 
                            (input)="searchResultsTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 35px">
                    <button (click)="importCheckedThings()" class="btn btn-primary" style="margin-top: -2px; margin-left: 10px; margin-right: 10px;" type="button">Add Checked Items</button>
                </div>
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr style="height: 40px;">
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        <p-checkbox
                            [(ngModel)]="rowData.checked" binary="true" id="{{rowData.checked}}" name="{{rowData.checked}}"
                            [ngModelOptions]="{standalone: true}">
                        </p-checkbox>
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.thingId }}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.thingName }}
                    </td>

                    <td [ngStyle]="{'width': columns[3].width }" style="flex: none; border-width: 0px;">
                        {{ rowData.gateway_Type }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.city }}
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.region }}
                    </td>

                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.latitude }}
                    </td>

                    <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.longitude }}
                    </td>

                    <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.subscription_Type }}
                    </td>

                    <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.user_Email }}
                    </td>

                </tr>
            </ng-template>

            <ng-template #noResults>
                <p *ngIf="importSearchResults.length <= 0">No Results Found</p>
            </ng-template>
        </p-table>
        <br>
    </div>
</ng-template>

<!-- SenTek & Soiltech Sensor Results -->

<ng-template #searchSensorResultsTemplateA>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="schedule-modal">
    <!-- <div class="modal-content schedule-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Search Results</h5>
            <button
            (click)="searchResultsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <p-table #searchResultsTable [columns]="importSearchResultSenTekCols" [scrollable]="true" [value]="importSearchResults" scrollHeight="40em">
            <ng-template pTemplate="caption">
                <div style="text-align: left; display: flex; gap: 8px;">
                    <label for="sensorGroupName" style="font-size: 17px; margin-top: 5px;">Search</label>
                    <i class="fa fa-search" style="margin:12px 0 0 0"></i>
                    <input type="text" pInputText size="22" placeholder="Search Table" 
                            (input)="searchResultsTable.filterGlobal($event.target.value, 'contains')" style="width:auto; height: 35px">
                    <label style="font-size: 14px; margin-top: 6px; margin-left: 10px;">Date Color Key:</label>
                    <label style="font-size: 14px; margin-top: 6px; color: #64a70b"><i class="fa-solid fa-square"></i> Day,</label>
                    <label style="font-size: 14px; margin-top: 6px; color: #dadb26"><i class="fa-solid fa-square"></i> Week,</label>
                    <label style="font-size: 14px; margin-top: 6px; color: #ff9551"><i class="fa-solid fa-square"></i> Month,</label>
                    <label style="font-size: 14px; margin-top: 6px; color: purple"><i class="fa-solid fa-square"></i> 6 Months,</label>
                    <label style="font-size: 14px; margin-top: 6px; color: #f93232"><i class="fa-solid fa-square"></i> 6+ Months</label>
                    <button (click)="importCheckedThings()" class="btn btn-primary" style="margin-left: 130px;" type="button">Add Checked Items</button>
                </div>
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                    <!-- <p-sortIcon *ngIf="col.header=='Name' || col.header=='ID'" [field]="col.field"></p-sortIcon> -->
                </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr style="height: 40px;">
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        <p-checkbox
                        [(ngModel)]="rowData.checked" binary="true" id="{{rowData.checked}}" name="{{rowData.checked}}"
                        [ngModelOptions]="{standalone: true}">
                        </p-checkbox>
                    </td>
                    
                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="!rowData.isLoadingLastReading" [ngStyle]="{'color': rowData.lastReportColor }">
                            <i class="fa-solid fa-square"></i>
                            {{ rowData.lastReportDate | date : 'medium' }}
                        </div>
                        <div *ngIf="rowData.isLoadingLastReading" style="font-size: 6px;">
                            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.thingId }}
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.thingName }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.latitude }}
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.longitude }}
                    </td>
                </tr>
            </ng-template>

            <ng-template #noResults>
                <p *ngIf="importSearchResults.length <= 0">No Results Found</p>
            </ng-template>
        </p-table>
        <br>
    </div>
</ng-template>


<!-- MC Sensor Compare Details -->

<ng-template #searchSensorResultsTemplateB>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="compareMcSensorResults-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">MC Sensor Compare Details -> Device Class ({{ deviceClass }})</h5>
            <button
            (click)="sensorResultsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <p-table #searchMCDeviceClassSensorTable [columns]="compareMcSensorResultsTableCols" [scrollable]="true" [value]="currentImportItem.compareSyncResults.sensors" scrollHeight="36em"
                                                                                    [exportFunction]="exportCsv" sortField="particleNew" sortOrder="-1">
            <ng-template pTemplate="caption">
                <div class="form-group" style="text-align: left; display: flex; gap: 15px;">
                    <div style="margin-top: 14px; display: flex; gap: 10px;">
                        <form>
                            <label for="previewResults" style="font-size: 15px;">Search</label>
                            <i class="fa fa-search" style="margin:4px 4px 0 10px"></i>
                            <input type="text" pInputText placeholder="Search Table" (input)="searchMCDeviceClassSensorTable.filterGlobal($event.target.value, 'contains')" style="height: 38px; width: 250px;">
                        </form>

                        <div>
                            <button (click)="searchMCDeviceClassSensorTable.exportCSV()" class="btn btn-success">Export</button>
                        </div>
                    </div>

                    <div>
                        <div style="margin-left: 240px; display: flex; gap: 10px;">
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400;">MC Count</label>
                            </div>

                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102eed;">{{global.appName}}.New</label>
                            </div>
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">{{global.appName}}.Name</label>
                            </div>
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">{{global.appName}}.ProdId</label>
                            </div>
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">{{global.appName}}.Group</label>
                            </div>
                            
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">Par.New</label>
                            </div>
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">Par.Name</label>
                            </div>
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">Par.ProdId</label>
                            </div>
                            <div class="form-group text-center" style="width: 70px;">
                                <label style="font-weight: 400; color: #c8102e;">Par.Group</label>
                            </div>
                        </div>

                        <div style="margin-left: 240px; display: flex; gap: 10px;">
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="MCCount" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareSyncResults.sensors.length" required>
                            </div>

                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="KigNew" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.kigNew" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="KigNameUpdate" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.kigNameUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="KigProdIdUpdate" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.kigProdIdUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="KigGroupUpdate" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.kigGroupUpdate" required>
                            </div>

                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="ParNew" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.particleNew" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="ParNameUpdate" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.particleNameUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="ParProdIdUpdate" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.particleProdIdUpdate" required>
                            </div>
                            <div class="form-group" style="width: 70px;">
                                <input type="text" name="ParGroupUpdate" style="text-align: center; height: 30px;" class="form-control" disabled="true" [(ngModel)]="currentImportItem.compareStats.particleGroupUpdate" required>
                            </div>
                        </div>
                    </div>

                </div>
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                    <!-- <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon> -->
                </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr style="height: 40px;">

                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.uid }}
                    </td>

                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.name }}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.product_id }}
                    </td>

                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.product_name }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                        {{ rowData.group_names.join(',') }}
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.kigNew" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>
                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.kigNameUpdate" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>
                    <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.kigProdIdUpdate" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>
                    <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.kigGroupUpdate" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>

                    <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.particleNew" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>
                    <td [ngStyle]="{'width': columns[10].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.particleNameUpdate" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>
                    <td [ngStyle]="{'width': columns[11].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.particleProdIdUpdate" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>
                    <td [ngStyle]="{'width': columns[12].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="rowData.particleGroupUpdate" class="text-center"><i class="fa-solid fa-square" style="color: red;"></i></div>
                    </td>

                    <td [ngStyle]="{'width': columns[13].width}" style="flex: none; border-width: 0px;">
                        <div *ngIf="this.importSchedule.userFeatureAccess['EditSchedule'] && (rowData.kigNew || rowData.kigNameUpdate || rowData.kigProdIdUpdate || rowData.kigGroupUpdate  ||
                                        rowData.particleNew || rowData.particleNameUpdate || rowData.particleProdIdUpdate || rowData.particleGroupUpdate)"
                            (click)="syncMcSensor(rowData)" aria-hidden="true" class="fa-solid fa-right-left text-center"
                            style="color: black; cursor: pointer; font-size: 14px; margin-left: 8px;">
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template #noResults>
                <p *ngIf="importSearchResults.length <= 0">No Results Found</p>
            </ng-template>
        </p-table>
        <br>
    </div>
</ng-template>


<ng-template #searchSensorDataResultsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="dataResults-modal">
    <!-- <div class="modal-content dataResults-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Preview Data</h5>
            <button
            (click)="dataPreviewResultsRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <p-table #searchPreviewResultsTable [columns]="importDataPreviewResultCols" [scrollable]="true" [value]="importDataPreviewResults" scrollHeight="36em"
                                                                                    [exportFunction]="exportCsv" sortField="timeStamp" sortOrder="-1">
            <ng-template pTemplate="caption">
                <div style="display: flex; gap: 15px; align-items: center;">
                    <div class="form-group" style="font-size: 15px;">
                        <label for="UserGroup">Displayed Timezone:</label>
                        <div style="font-size: 14px; margin-top: 2px; margin-bottom: 10px;">
                            <input type="radio" [(ngModel)]="selectedTimeZone" name="Local" value="Local" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
                            <label style="padding-left: 5px; padding-right: 20px;">Local</label>
                            <input type="radio" [(ngModel)]="selectedTimeZone" name="Source" value="Source" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
                            <label style="padding-left: 5px; padding-right: 20px;">Source</label>
                            <input type="radio" [(ngModel)]="selectedTimeZone" name="UTC" value="UTC" (ngModelChange)="selectedTimeZoneChanged()" style="cursor: pointer;"/>
                            <label style="padding-left: 5px; padding-right: 20px;">UTC (GMT+0)</label>
                        </div>
                    </div>

                    <div class="form-group" style="margin-top: 10px; margin-bottom: 10px;">
                        <input (datesUpdated)="datesUpdated()" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                            [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                            ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; height: 35px; font-size: medium;" />
                    </div>

                    <div>
                        <button (click)="searchPreviewResultsTable.exportCSV()" class="btn btn-success">Export</button>
                    </div>

                    <div class="fas fa-chart-line" (click)="showDataPreviewChart(quickChart)" style="color:#8d3131; cursor: pointer; font-size: 20px;"></div>
                </div>

                <div class="form-group" style="text-align: left; margin-top: 10px;">
                    <form>
                        <label for="previewResults" style="font-size: 15px;">Search</label>
                        <i class="fa fa-search" style="margin:4px 4px 0 10px"></i>
                        <input type="text" pInputText size="15" placeholder="Search Table" 
                                (input)="searchPreviewResultsTable.filterGlobal($event.target.value, 'contains')" style="height: 35px">
                    </form>
                </div>
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr>
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                    <!-- <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon> -->
                </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr style="height: 40px;">

                <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                    {{ rowData.timeStamp | date : 'medium' }}
                </td>

                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                    {{ rowData.dataType }}
                </td>

                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                    {{ rowData.value }}
                </td>

                </tr>
            </ng-template>

            <ng-template #noResults>
                <p *ngIf="importSearchResults.length <= 0">No Results Found</p>
            </ng-template>
        </p-table>
        <br>
    </div>
</ng-template>


<ng-template #importNowTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="import-modal">
    <!-- <div class="modal-content import-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Manual Import</h5>
            <button
            (click)="scheduleImportNowRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <div style="display: flex; gap: 25px; align-items: center;">
                <div class="form-group" style="margin-top: 10px; margin-bottom: 10px;">
                    <input (datesUpdated)="importNowDatesUpdated()" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                        [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                        ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; height: 35px; font-size: medium;" />
                </div>
                <div *ngIf="selectedDateRange.startDate != undefined && selectedDateRange.endDate != undefined">
                    <button (click)="importNow()" class="btn btn-success">Import Now</button>
                </div>
                <div *ngIf="importNowIsLoading" style="margin-top: 5px; font-size: 12px;">
                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                </div>
                <div *ngIf="!importNowIsLoading" style="margin-top: 5px; font-size: 16px;">
                    Results: {{ importNowCount }}
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #quickChart>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="quickChart">
    <!-- <div class="modal-content quickChart"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Chart:&nbsp;&nbsp;Preview Data</h5>
            <button
                (click)="chartModalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div style="display: flex; padding-left: 10px;">
            <div id="chartContainer" style="background-color: white; font-weight: 500;">
                <ngx-charts-line-chart  #sensorChartRef
                    [view]="view" [scheme]="chartOptions.colorScheme"
                    [results]="chart" [gradient]="gradient" [xAxis]="chartOptions.showXAxis"
                    [yAxis]="chartOptions.showYAxis" [legend]="chartOptions.showLegend"
                    [showXAxisLabel]="chartOptions.showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                    [xAxisLabel]="chartOptions.xAxisLabel" [yAxisLabel]="chartOptions.yAxisLabel"
                    [autoScale]="chartOptions.autoScale" [xAxisTickFormatting]="chartOptions.axisFormat"
                    [legendTitle]="chartOptions.legendTitle" [timeline]="chartOptions.timeline"
                    [yScaleMin]="yScaleMin" [yScaleMax]="yScaleMax">
                </ngx-charts-line-chart>
            </div>

            <div>
                <button (click)="showDataPointsOnChart(sensorChartRef)" class="btn btn-primary btn-sm" type="button" style="margin-bottom: 15px; margin-top: 15px; width: 190px;">Show Data Points</button>
                <button (click)="charting.saveChartAsImage('chartContainer', 'chart')" class="btn btn-primary btn-sm" type="button" style="margin-left: 45px;" ><i class="fa-solid fa-download"></i> JPG</button>

                <div style="font-weight: bold;">
                    Reading Types
                </div>
                <table class="table" style="width:100%;">
                    <tr *ngFor="let dataType of dataTypes; let i = index" style="font-size: 13px; line-height: 8px;">
                        <td>
                            <p-checkbox
                                style="padding: 0px;"
                                [(ngModel)]="dataType.checked" binary="true" id="{{dataType.id}}" name="{{dataType.id}}"
                                [ngModelOptions]="{standalone: true}"
                                (onChange)="updateChartData()" >
                            </p-checkbox>
                            <label (click)="updateChartData()" style="cursor: pointer; color: rgb(0, 123, 255);">
                                {{dataType.type}}
                            </label>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #sampleCSVFormatsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="csvExamples-modal">
    <!-- <div class="modal-content csvExamples-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Sample CSV Formats</h5>
            <button
            (click)="sampleCSVFormatRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <label style="margin-bottom: 10px;">Example #1:  CSV File with required header fields plus one data field and two rows of data</label>
            <table class="table" style="width:100%; border: 1px dotted rgb(156, 156, 156); font-size: 14px;">
                <tr style="font-weight: 600;">
                    <td>Tag</td>
                    <td>UUID</td>
                    <td>CreatedDate</td>
                    <td>moisture</td>
                </tr>
                <tr>
                    <td>ProjNitrogen</td>
                    <td>b4b170e6-32ad-a351-a207-1700e425223b</td>
                    <td>2021-06-02T14:00:01Z</td>
                    <td>23.5</td>
                </tr>
                <tr>
                    <td>ProjNitrogen</td>
                    <td>b170e6ad351207700e4</td>
                    <td>2021-06-02T14:30:01Z</td>
                    <td>65.234</td>
                </tr>
            </table>

            <label style="margin-bottom: 10px; margin-top: 20px;">Example #2:  CSV File with required header fields, GPS header info, and two data fields</label>
            <table class="table" style="width:100%; border: 1px dotted rgb(156, 156, 156); font-size: 14px;">
                <tr style="font-weight: 600;">
                    <td>Tag</td>
                    <td>UUID</td>
                    <td>CreatedDate</td>
                    <td>temp</td>
                    <td>humidity</td>
                    <td>gpsLat</td>
                    <td>gpsLong</td>
                    <td>gpsAlt</td>
                    <td>LocationDescription</td>
                </tr>
                <tr>
                    <td>Solinist_GN</td>
                    <td>b170e0e4</td>
                    <td>2022-08-17T9:30:00Z</td>
                    <td>23.5</td>
                    <td>65.4</td>
                    <td>40.941060</td>
                    <td>-94.616244</td>
                    <td>768</td>
                    <td>Gaesser-G1</td>
                </tr>
            </table>

            <label style="margin-bottom: 10px; margin-top: 20px;">Note: The header row is required and you must remove all blank/unused lines before selecting and importing your csv file. Also note that the CreatedDate field must be formatted as shown in the examples above and that the time will be interpreted as given in UTC.</label>
        </div>
    </div>
</ng-template>


<ng-template #soiltechReadingTypeKey>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="soiltechKey-modal">
    <!-- <div class="modal-content soiltechKey-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Soiltech Reading Type Key</h5>
            <button
            (click)="readingTypeKeyRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            "d": device ID <br>
            "ut": uptime seconds <br>
            "mode": growth=0, tracking=1, storage=2, pre-plant=3, idle=255 <br>
            "sys": internal sensor state <br>
            "m0": raw moisture low during sampling <br>
            "m1": raw moister high during sampling <br>
            "fwv": firmware version <br>
            "tsl": server timestamp <br>
            "ts": device timestamp <br>
            "m": raw moisture (unitless) <br>
            "h": external humidity <br>
            "t": external temperature (Celsius) <br>
            "h2": internal humidity <br>
            "t2": internal temperature (Celsius) <br>
            "bc": boot count <br>
            "wc": moisture volumetric % <br>
            "mp": moisture available % <br>
            "st": soil type: clay=1, sand=2, silt=3, manual=4 <br>
            "tF": external temperature (Fahrenheit) <br>
            "t2F": internal temperature (Fahrenheit) <br>
            "lat": sensor latitude <br>
            "lng": sensor longitude <br>
            "alt": sensor altitude <br>
            "rssi": received signal strength indicator <br>
        </div>
    </div>
</ng-template>